<template>
  <div class="mb-16 mt-20 2xl:mt-32">
    <div class="flex justify-between items-center">
      <base-link :href="contact">
        {{ contactText }}
        <base-icon icon="external-link" class="ml-1" />
      </base-link>
      <div class="w-32">
        <SelectLocale theme="light" size="sm" />
      </div>
    </div>
    <hr class="my-2" />
    <div class="justify-center w-full hidden mt-12 lg:flex">
      <div class="w-72 p-1">
        <img
          alt="#BuildFor2030 Hackathon Hero"
          class="self-center"
          src="@/assets/media/hackathon_hero.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {BaseIcon, BaseLink} from '@/components/base'
import SelectLocale from '@/components/shared/SelectLocale.vue'

export default {
  computed: {
    contactText() {
      return this.$t('mygwf.components.Guest.footer.contact')
    },
    contact() {
      return this.$store.getters['app/support']
    },
  },
  components: {
    SelectLocale,
    BaseLink,
    BaseIcon,
  },
}
</script>

<style scoped>
.footer {
  @apply w-full border-t pt-3 flex items-center justify-between;
}
</style>
